import { Injectable } from '@angular/core';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { HttpClient, HttpParams } from '@angular/common/http';
import {
  IOrganisationOrderPreference,
  IOrganisationOrderPreferenceSearch,
} from '../interfaces/organisation-order-preference';

@Injectable({ providedIn: 'root' })
export class OrganisationOrderPeferenceService extends BaseDataService {
  private url = '/api/organisationorderprefs';
  private entityTitle = 'Organisation Order Preferences';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  public search(
    search: IOrganisationOrderPreferenceSearch = {},
  ): Promise<IOrganisationOrderPreference[]> {
    return this.http
      .get<IOrganisationOrderPreference[]>(`${this.url}`, {
        params: this.constructHttpParams(search),
      })
      .toPromise();
  }

  public saveCustomerOrderPreferences(customerStructureTaggingDataDTO): Promise<any[]> {
    return this.http
      .post<any>(`${this.url}/savecustomerorderpreferences`, customerStructureTaggingDataDTO)
      .toPromise();
  }

  public saveSupplierOrderPreferences(supplierStructureTaggingDataDTO): Promise<any[]> {
    return this.http
      .post<any>(`${this.url}/savesupplierorderpreferences`, supplierStructureTaggingDataDTO)
      .toPromise();
  }
}
